/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HSAUnit
 */
export interface HSAUnit {
    /**
     * 
     * @type {string}
     * @memberof HSAUnit
     */
    hsaIdentity?: string;
    /**
     * 
     * @type {string}
     * @memberof HSAUnit
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof HSAUnit
     */
    isCareProvider?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HSAUnit
     */
    isCareUnit?: boolean;
    /**
     * 
     * @type {HSAUnit}
     * @memberof HSAUnit
     */
    responsibleCareProvider?: HSAUnit;
    /**
     * 
     * @type {Array<HSAUnit>}
     * @memberof HSAUnit
     */
    careUnits?: Array<HSAUnit>;
}

export function HSAUnitFromJSON(json: any): HSAUnit {
    return HSAUnitFromJSONTyped(json, false);
}

export function HSAUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): HSAUnit {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'hsaIdentity': !exists(json, 'hsaIdentity') ? undefined : json['hsaIdentity'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'isCareProvider': !exists(json, 'isCareProvider') ? undefined : json['isCareProvider'],
        'isCareUnit': !exists(json, 'isCareUnit') ? undefined : json['isCareUnit'],
        'responsibleCareProvider': !exists(json, 'responsibleCareProvider') ? undefined : HSAUnitFromJSON(json['responsibleCareProvider']),
        'careUnits': !exists(json, 'careUnits') ? undefined : ((json['careUnits'] as Array<any>).map(HSAUnitFromJSON)),
    };
}

export function HSAUnitToJSON(value?: HSAUnit | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'hsaIdentity': value.hsaIdentity,
        'name': value.name,
        'isCareProvider': value.isCareProvider,
        'isCareUnit': value.isCareUnit,
        'responsibleCareProvider': HSAUnitToJSON(value.responsibleCareProvider),
        'careUnits': value.careUnits === undefined ? undefined : ((value.careUnits as Array<any>).map(HSAUnitToJSON)),
    };
}

